import { doc, setDoc, increment, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { ensureMetricsToggleListener, isDailyReadsEnabled } from "../config/metricsToggle";

// Increments daily Firestore read counters by coarse entity.
// Creates/merges a document per day (YYYY-MM-DD) in collection `dailyReads`.
export async function incrementDailyReads(entityKey, amount = 1, date = new Date()) {
  try {
    ensureMetricsToggleListener();
    if (!isDailyReadsEnabled()) return;
    const dayId = date.toISOString().slice(0, 10); // e.g., 2025-01-31
    const ref = doc(db, "dailyReads", dayId);
    await setDoc(
      ref,
      {
        [entityKey]: increment(amount),
        total: increment(amount),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (error) {
    console.error("incrementDailyReads error:", error);
  }
}
